/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon64Regular = forwardRef('ArrowDim2DiagMaxRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M37.5 6a1.5 1.5 0 0 0 0 3h15.379l-17.44 17.44a1.5 1.5 0 0 0 2.122 2.12L55 11.122V26.5a1.5 1.5 0 0 0 3 0V11a5 5 0 0 0-5-5H37.5Z" }),
        React.createElement("path", { d: "M28.56 37.56a1.5 1.5 0 0 0-2.12-2.12L9 52.878V37.5a1.5 1.5 0 0 0-3 0V53a5 5 0 0 0 5 5h15.5a1.5 1.5 0 0 0 0-3H11.121l17.44-17.44Z" })));
});
